module.exports = __webpack_public_path__ + "static/media/area_1_image.c1329ee9.jpg";